// extracted by mini-css-extract-plugin
var _1 = "ExpansionPanelStyle-module__question___Hc4_b";
var _2 = "ExpansionPanelStyle-module__question-active___kIFUS";
var _3 = "ExpansionPanelStyle-module__question-active___kIFUS";
var _4 = "ExpansionPanelStyle-module__show-all___BNNAM";
var _5 = "ExpansionPanelStyle-module__show-all___BNNAM";
export { _1 as "question", _2 as "question-active", _3 as "questionActive", _4 as "show-all", _5 as "showAll" }
